import Image from "next/image";

import { useTranslation } from "@flare/i18n";
import { Heading, Text } from "@flare/ui/components";

import mainImg from "@/../public/next/images/slot_is_taken.png";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

export default function SlotIsTaken() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer className="pt-0 md:pt-0">
        <StepContent className="m-auto flex flex-col items-center justify-center">
          <Image
            src={mainImg}
            alt={t("FUNNEL_SLOT_IS_TAKEN_IMAGE_ALT")}
            width={240}
          />
          <Heading variant="h4" alignment="center" className="mt-6">
            {t("FUNNEL_SLOT_IS_TAKEN_TITLE")}
          </Heading>
          <Text className="mt-3 text-center">
            {t("FUNNEL_SLOT_IS_TAKEN_TEXT")}
          </Text>
        </StepContent>
        <ActionsContainer>
          <ActionButton> {t("FUNNEL_SLOT_IS_TAKEN_BUTTON")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
